import { render, staticRenderFns } from "./deployment_status_badge.vue?vue&type=template&id=5f89577b"
import script from "./deployment_status_badge.vue?vue&type=script&lang=js"
export * from "./deployment_status_badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports